module.exports = __webpack_public_path__ + "570c672116ef9cbc87d6fbfffb885682.svg";